import { IUserGroupPermission } from 'api/api';
import { hasAtLeast } from 'utilities/roles-util';
import { AuthPageRequirement } from './auth-requirements';

export const authPermissionCheck = (
	userGroupPermissions: IUserGroupPermission[],
	authPageRequirement: AuthPageRequirement
): boolean => {
	// User must parse one of these validations
	return (
		(authPageRequirement.minRole !== undefined &&
			userGroupPermissions.some(usr => hasAtLeast(usr.roleType, authPageRequirement.minRole!))) || // User has at least minRole
		(authPageRequirement.exactRoles?.length &&
			userGroupPermissions.some(usr => authPageRequirement.exactRoles!.includes(usr.roleType))) || // At least one role within the list of exactRoles
		(!!authPageRequirement.isPartnerArea && userGroupPermissions.some(usr => usr.isPartnerArea)) // User isPartnerArea
	);
};
